import * as $ from 'jquery';

$(document).ready(function(){

    var initInnerHeight = window.innerHeight;
    var offset = 100;

    function setInnerHeight(innerHeight) {
        if (innerHeight == initInnerHeight || Math.abs(initInnerHeight-innerHeight) > offset)
            $('#transparent').css('min-height', innerHeight-115 + 'px');
    }

    window.addEventListener('resize', () => { setInnerHeight(window.innerHeight) });
    setInnerHeight(window.innerHeight);
    $('#transparent .fill').fadeTo(300, 1);
});